const F = {
  red: {
    50: "#FFEFEC",
    100: "#FFD8D0",
    200: "#FF917E",
    300: "#FF5948",
    400: "#FF412E",
    500: "#EB0000",
    600: "#B10000",
    700: "#890000",
    800: "#6A0000",
    900: "#530000"
  },
  orange: {
    50: "#FFF2E4",
    100: "#FDEBD7",
    200: "#FFD4A4",
    300: "#FFC07F",
    400: "#FFAA5C",
    500: "#FF933C",
    600: "#DB7821",
    700: "#AF5B0B",
    800: "#8D4802",
    900: "#693300"
  },
  lime: {
    50: "#EAF8E3",
    100: "#D2F1C3",
    200: "#BDE9A7",
    300: "#A1DC82",
    400: "#90D466",
    500: "#8CD062",
    600: "#67B135",
    700: "#457F1C",
    800: "#356610",
    900: "#244A07"
  },
  indigo: {
    50: "#F0F2FF",
    100: "#DFE5FF",
    200: "#C2CCFF",
    300: "#9DAAFF",
    400: "#7B86F8",
    500: "#5C62E1",
    600: "#4547BC",
    700: "#343397",
    800: "#262579",
    900: "#1C1B60"
  },
  caribbeanGreen: {
    50: "#E1FAF0",
    100: "#B8F5DF",
    200: "#91EECF",
    300: "#62E1BB",
    400: "#3CD4AB",
    500: "#00C39A",
    600: "#00A580",
    700: "#008162",
    800: "#00674D",
    900: "#004B37"
  }
}, r = {
  vxModels: {
    50: "#FFF1F0",
    100: "#FFD0CC",
    200: "#FFB8B1",
    300: "#FF8D82",
    400: "#FF6354",
    500: "#FF4D3C",
    600: "#C53C30",
    700: "#A3382E",
    800: "#872E26",
    900: "#631D17"
  },
  // linkedin: {
  //   '50': '#E8F4F9',
  //   '100': '#CFEDFB',
  //   '200': '#9BDAF3',
  //   '300': '#68C7EC',
  //   '400': '#34B3E4',
  //   '500': '#00A0DC',
  //   '600': '#008CC9',
  //   '700': '#0077B5',
  //   '800': '#005E93',
  //   '900': '#004471',
  // },
  // facebook: {
  //   '50': '#E8F4F9',
  //   '100': '#D9DEE9',
  //   '200': '#B7C2DA',
  //   '300': '#6482C0',
  //   '400': '#4267B2',
  //   '500': '#385898',
  //   '600': '#314E89',
  //   '700': '#29487D',
  //   '800': '#223B67',
  //   '900': '#1E355B',
  // },
  // messenger: {
  //   '50': '#D0E6FF',
  //   '100': '#B9DAFF',
  //   '200': '#A2CDFF',
  //   '300': '#7AB8FF',
  //   '400': '#2E90FF',
  //   '500': '#0078FF',
  //   '600': '#0063D1',
  //   '700': '#0052AC',
  //   '800': '#003C7E',
  //   '900': '#002C5C',
  // },
  // whatsapp: {
  //   '50': '#dffeec',
  //   '100': '#b9f5d0',
  //   '200': '#90edb3',
  //   '300': '#65e495',
  //   '400': '#3cdd78',
  //   '500': '#22c35e',
  //   '600': '#179848',
  //   '700': '#0c6c33',
  //   '800': '#01421c',
  //   '900': '#001803',
  // },
  // twitter: {
  //   '50': '#E5F4FD',
  //   '100': '#C8E9FB',
  //   '200': '#A8DCFA',
  //   '300': '#83CDF7',
  //   '400': '#57BBF5',
  //   '500': '#1DA1F2',
  //   '600': '#1A94DA',
  //   '700': '#1681BF',
  //   '800': '#136B9E',
  //   '900': '#0D4D71',
  // },
  telegram: {
    50: "#E3F2F9",
    100: "#C5E4F3",
    200: "#A2D4EC",
    300: "#7AC1E4",
    400: "#47A9DA",
    500: "#0088CC",
    600: "#007AB8",
    700: "#006BA1",
    800: "#005885",
    900: "#003F5E"
  }
}, a = {
  whiteAlpha: {
    50: "rgba(255, 255, 255, 0.04)",
    100: "rgba(255, 255, 255, 0.06)",
    200: "rgba(255, 255, 255, 0.08)",
    300: "rgba(255, 255, 255, 0.12)",
    400: "rgba(255, 255, 255, 0.24)",
    500: "rgba(255, 255, 255, 0.36)",
    600: "rgba(255, 255, 255, 0.60)",
    700: "rgba(255, 255, 255, 0.64)",
    800: "rgba(255, 255, 255, 0.80)",
    900: "rgba(255, 255, 255)"
  },
  blackAlpha: {
    50: "rgba(0, 0, 0, 0.04)",
    100: "rgba(0, 0, 0, 0.06)",
    200: "rgba(0, 0, 0, 0.08)",
    300: "rgba(0, 0, 0, 0.16)",
    400: "rgba(0, 0, 0, 0.24)",
    500: "rgba(0, 0, 0, 0.36)",
    600: "rgba(0, 0, 0, 0.48)",
    700: "rgba(0, 0, 0, 0.64)",
    800: "rgba(0, 0, 0, 0.80)",
    900: "rgba(0, 0, 0, 0.92)"
  },
  coldAlpha: {
    50: "rgba(6, 20, 55, 0.04)",
    100: "rgba(6, 20, 55, 0.06)",
    200: "rgba(6, 20, 55, 0.08)",
    300: "rgba(6, 20, 55, 0.16)",
    400: "rgba(6, 20, 55, 0.24)",
    500: "rgba(6, 20, 55, 0.36)",
    600: "rgba(6, 20, 55, 0.48)",
    700: "rgba(6, 20, 55, 0.64)",
    800: "rgba(6, 20, 55, 0.80)",
    900: "rgba(6, 20, 55, 0.92)"
  },
  warmAlpha: {
    50: "rgba(41, 36, 20, 0.04)",
    100: "rgba(41, 36, 20, 0.06)",
    200: "rgba(41, 36, 20, 0.08)",
    300: "rgba(41, 36, 20, 0.16)",
    400: "rgba(41, 36, 20, 0.24)",
    500: "rgba(41, 36, 20, 0.36)",
    600: "rgba(41, 36, 20, 0.48)",
    700: "rgba(41, 36, 20, 0.64)",
    800: "rgba(41, 36, 20, 0.80)",
    900: "rgba(41, 36, 20, 0.92)"
  }
}, b = {
  gray: {
    900: "#151A26",
    800: "#292F40",
    700: "#414655",
    600: "#585D6A",
    500: "#747883",
    400: "#8F929B",
    300: "#ADAFB5",
    200: "#CDCED2",
    100: "#E3E4E6",
    50: "#F1F2F3"
  },
  coldGray: {
    900: "#0A183B",
    800: "#1F2F4F",
    700: "#384664",
    600: "#505E79",
    500: "#6D7990",
    400: "#8A93A6",
    300: "#A9B0BE",
    200: "#C9CED7",
    100: "#E2E5E9",
    50: "#F0F2F4"
  },
  trueGray: {
    900: "#1A1A1A",
    800: "#2F2F2F",
    700: "#464646",
    600: "#5D5D5D",
    500: "#787878",
    400: "#929292",
    300: "#AFAFAF",
    200: "#CECECE",
    100: "#E5E5E5",
    50: "#F2F2F2"
  },
  warmGray: {
    900: "#1D1915",
    800: "#332E28",
    700: "#4C453D",
    600: "#645C53",
    500: "#7F776E",
    400: "#999188",
    300: "#B4AFA7",
    200: "#D1CDC9",
    100: "#E6E4E2",
    50: "#F3F2F1"
  }
}, g = {
  transparent: "transparent",
  current: "currentColor",
  black: "#000000",
  white: "#FFFFFF",
  cold: "#061437",
  warm: "#292414"
}, C = {
  lightBackground: "#F3F2F1",
  darkBackground: "#061437",
  ...g,
  ...b,
  ...F,
  ...a,
  ...r
}, E = C;
export {
  C as colors,
  E as default
};
